import OptionsButton2, { ItemModel } from "@cmp/buttons/optionsButton2"
import { ListItemIcon, ListItemText, SvgIcon } from "@mui/material"
import AppIcon from "@utils/appIcon"
import appIcons from "@utils/appIcons"

export const CourseOptionsMenu = (props: {
  isOptional: boolean
  onClickRemove: () => void
  onToggleOptional: () => void
}) => {
  const { isOptional, onClickRemove, onToggleOptional } = props

  const toggleOptionalItem: ItemModel = {
    type: "menu-item",
    props: {
      key: "toggle-optional",
      children: (
        <>
          <ListItemIcon>
            <AppIcon icon={isOptional ? appIcons.check : appIcons.flag03} />
          </ListItemIcon>
          <ListItemText
            primary={isOptional ? "Mark as required" : "Mark as optional"}
          />
        </>
      ),
      onClick: onToggleOptional,
    },
  }

  const removeCourseItem: ItemModel = {
    type: "menu-item",
    props: {
      key: "remove",
      children: (
        <>
          <ListItemIcon>
            <AppIcon icon={appIcons.trash03} />
          </ListItemIcon>
          <ListItemText primary="Remove" />
        </>
      ),
      onClick: onClickRemove,
    },
  }

  const trackMenuOptions = [toggleOptionalItem, removeCourseItem]
  return (
    <OptionsButton2
      buttonModel={{
        type: "icon",
        props: {
          children: <SvgIcon inheritViewBox component={appIcons.dots} />,
        },
      }}
      items={trackMenuOptions}
    />
  )
}
